// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1769":"f306bfff","6056":"5beebd08","8460":"2585bc55"}[chunkId] + ".chunk.css";
};